import { Link } from "react-router-dom"
import QuantityControlButton from '../Order/QuantityControlButton';
 
const TestCard = ({ id, title, description, price, visit_type, quantity ,category_name,mrp_price}) => {
  const formattedPrice = typeof price === "string" ? Number.parseInt(price.replace("₹", "")) : price;

  return (
    <div className="bg-white p-4 rounded-2xl hover:shadow-sm transition-shadow border border-[#E0E0E0] hover:border-[#951C25]/30">
      <Link to={'/' + encodeURIComponent(category_name.replace(/ /g, '-')) + '/' + encodeURIComponent(title.replace(/ /g, '-')) + '-' + id} className="block mb-3">
        <h3 className="text-base font-medium text-[#4A4A4A] mb-2 line-clamp-2 min-h-[3rem]">{title}</h3>
        <p className="text-xs text-[#4A4A4A]/70 mb-3 line-clamp-3 min-h-[2.5rem]">{description}</p>
      </Link>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-[#951C25]">₹{formattedPrice} <span className="line-through text-gray-500 ml-1">₹{mrp_price}</span></span>
        <QuantityControlButton
          id={id}
          name={title}
          price={formattedPrice}
          variant="simple"
          className="text-xs"
          visit_type={visit_type}
          quantity={quantity}
          
        />
      </div>
    </div>
  );
};

export default TestCard;
